import { createImageVariantConfig, types as sdkTypes } from '../../util/sdkLoader';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { storableError } from '../../util/errors';
import { fetchStripeAccount } from '../../ducks/stripeConnectAccount.duck';
import { isBookingProcessAlias } from '../../transactions/transaction';
import { getDefaultTimeZoneOnBrowser, getStartOf, getStartOfWeek, monthIdString, parseDateFromISO8601, stringifyDateToISO8601 } from '../../util/dates';
import { parse } from '../../util/urlHelpers';
import { uniqueBy } from '../../util/generators';
import { cancelUpcomingMail, createAlgoliaData, enhanceField, generateAIImages, generateBlogs, generateBlogTitleswithLabels, userActiveListings } from '../../util/api';
import { base64ToFile, denormalisedResponseEntities, urlToFile } from '../../util/data';
import { v4 as uuid4 } from 'uuid';
import { UploadImage, UploadVideo } from '../../util/cloudinary';
import { getCredits } from '../../util/api';
import { LISTING_ALOGLIA_REMOVABLE_FIELDS, LISTING_USER_PUBLIC_DATA_REMOVABLE_FIELDS } from '../../util/constants';
import moment from 'moment';
import { omit } from 'lodash';
import { getBlogsByListingId, updateBlogPost, deleteBlogPost, publishBlogPost } from '../../util/api';

const { UUID } = sdkTypes;
const getImageVariantInfo = listingImageConfig => {
    const {
        aspectWidth = 1,
        aspectHeight = 1,
        variantPrefix = 'listing-card',
    } = listingImageConfig;
    const aspectRatio = aspectHeight / aspectWidth;
    const fieldsImage = [
        `variants.${variantPrefix}`,
        `variants.${variantPrefix}-2x`,
    ];

    return {
        fieldsImage,
        imageVariants: {
            ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
            ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
        },
    };
};

// When navigating through weekly calendar,
// we want to merge new week-related data (inProgres, error) to weeklyExceptionQueries hashmap.
const mergeToWeeklyExceptionQueries = (
    weeklyExceptionQueries,
    weekStartId,
    newDataProps
) => {
    return weekStartId
        ? {
            weeklyExceptionQueries: {
                ...weeklyExceptionQueries,
                [weekStartId]: {
                    ...weeklyExceptionQueries[weekStartId],
                    ...newDataProps,
                },
            },
        }
        : {};
};

// When navigating through monthly calendar (e.g. when adding a new AvailabilityException),
// we want to merge new month-related data (inProgres, error) to monthlyExceptionQueries hashmap.
const mergeToMonthlyExceptionQueries = (
    monthlyExceptionQueries,
    monthId,
    newDataProps
) => {
    return monthId
        ? {
            monthlyExceptionQueries: {
                ...monthlyExceptionQueries,
                [monthId]: {
                    ...monthlyExceptionQueries[monthId],
                    ...newDataProps,
                },
            },
        }
        : {};
};

const filterPublicDataToAlgolia = (publicData = {}, removeables = []) => {
    const newObj = {};
    for (let key in publicData) {
      if (!removeables.includes(key)) {
        newObj[key] = publicData[key];
      }
    }
    return newObj;
  };

const getArrayOfNItems = n =>
    Array(n)
      .fill()
      .map((v, i) => i + 1)
      .slice(1);

// ================ Action types ================ //
export const GET_CREDITS_REQUEST = 'app/AIUpdateListingPage/GET_CREDITS_REQUEST';
export const GET_CREDITS_SUCCESS = 'app/AIUpdateListingPage/GET_CREDITS_SUCCESS';
export const GET_CREDITS_ERROR = 'app/AIUpdateListingPage/GET_CREDITS_ERROR';

export const FETCH_LISITNG_REQUESTED = 'app/AIUpdateListingPage/FETCH_LISITNG_REQUESTED';
export const FETCH_LISTING_SUCCESS = 'app/AIUpdateListingPage/FETCH_LISTING_SUCCESS';
export const FETCH_LISTING_ERROR = 'app/AIUpdateListingPage/FETCH_LISTING_ERROR';

export const FETCH_EXCEPTIONS_REQUEST = 'app/AIUpdateListingPage/FETCH_AVAILABILITY_EXCEPTIONS_REQUEST';
export const FETCH_EXCEPTIONS_SUCCESS = 'app/AIUpdateListingPage/FETCH_AVAILABILITY_EXCEPTIONS_SUCCESS';
export const FETCH_EXCEPTIONS_ERROR = 'app/AIUpdateListingPage/FETCH_AVAILABILITY_EXCEPTIONS_ERROR';

export const AIGENERATED_IMAGES_REQUESTED = 'app/AIUpdateListingPage/AIGENERATED_IMAGES_REQUESTED';
export const AIGENERATED_IMAGES_SUCCESS = 'app/AIUpdateListingPage/AIGENERATED_IMAGES_SUCCESS';
export const AIGENERATED_IMAGES_ERROR = 'app/AIUpdateListingPage/AIGENERATED_IMAGES_ERROR';

export const ENHANCE_FIELD_REQUEST = 'app/AIUpdateListingPage/ENHANCE_FIELD_REQUEST';
export const ENHANCE_FIELD_SUCCESS = 'app/AIUpdateListingPage/ENHANCE_FIELD_SUCCESS';
export const ENHANCE_FIELD_ERROR = 'app/AIUpdateListingPage/ENHANCE_FIELD_ERROR';

export const UPDATE_LISTING_REQUEST = 'app/AIUpdateListingPage/UPDATE_LISTING_REQUEST';
export const UPDATE_LISTING_SUCCESS = 'app/AIUpdateListingPage/UPDATE_LISTING_SUCCESS';
export const UPDATE_LISTING_ERROR = 'app/AIUpdateListingPage/UPDATE_LISTING_ERROR';

export const PUBLISH_LISTING_REQUEST = 'app/AIUpdateListingPage/PUBLISH_LISTING_REQUEST';
export const PUBLISH_LISTING_SUCCESS = 'app/AIUpdateListingPage/PUBLISH_LISTING_SUCCESS';
export const PUBLISH_LISTING_ERROR = 'app/AIUpdateListingPage/PUBLISH_LISTING_ERROR';

export const ADD_AVAILABILITY_EXCEPTION_REQUEST = 'app/AIUpdateListingPage/ADD_AVAILABILITY_EXCEPTION_REQUEST';
export const ADD_AVAILABILITY_EXCEPTION_SUCCESS = 'app/AIUpdateListingPage/ADD_AVAILABILITY_EXCEPTION_SUCCESS';
export const ADD_AVAILABILITY_EXCEPTION_ERROR = 'app/AIUpdateListingPage/ADD_AVAILABILITY_EXCEPTION_ERROR';

export const DELETE_AVAILABILITY_EXCEPTION_REQUEST = 'app/AIUpdateListingPage/DELETE_AVAILABILITY_EXCEPTION_REQUEST';
export const DELETE_AVAILABILITY_EXCEPTION_SUCCESS = 'app/AIUpdateListingPage/DELETE_AVAILABILITY_EXCEPTION_SUCCESS';
export const DELETE_AVAILABILITY_EXCEPTION_ERROR = 'app/AIUpdateListingPage/DELETE_AVAILABILITY_EXCEPTION_ERROR';

export const FETCH_EXTRA_EXCEPTIONS_SUCCESS = 'app/AIUpdateListingPage/FETCH_EXTRA_EXCEPTIONS_SUCCESS';

export const GENERATE_AI_IMAGES_REQUEST = 'app/AIUpdateListingPage/GENERATE_AI_IMAGES_REQUEST';
export const GENERATE_AI_IMAGES_SUCCESS = 'app/AIUpdateListingPage/GENERATE_AI_IMAGES_SUCCESS';
export const GENERATE_AI_IMAGES_ERROR = 'app/AIUpdateListingPage/GENERATE_AI_IMAGES_ERROR';

// Action types
const GENERATE_BLOG_TITLES_REQUEST = 'app/AIUpdateListingPage/GENERATE_BLOG_TITLES_REQUEST';
const GENERATE_BLOG_TITLES_SUCCESS = 'app/AIUpdateListingPage/GENERATE_BLOG_TITLES_SUCCESS';
const GENERATE_BLOG_TITLES_ERROR = 'app/AIUpdateListingPage/GENERATE_BLOG_TITLES_ERROR';

const GENERATE_BLOGS_REQUEST = 'app/AIUpdateListingPage/GENERATE_BLOGS_REQUEST';
const GENERATE_BLOGS_SUCCESS = 'app/AIUpdateListingPage/GENERATE_BLOGS_SUCCESS';
const GENERATE_BLOGS_ERROR = 'app/AIUpdateListingPage/GENERATE_BLOGS_ERROR';

const FETCH_BLOGS_REQUEST = 'app/AIUpdateListingPage/FETCH_BLOGS_REQUEST';
const FETCH_BLOGS_SUCCESS = 'app/AIUpdateListingPage/FETCH_BLOGS_SUCCESS';
const FETCH_BLOGS_ERROR = 'app/AIUpdateListingPage/FETCH_BLOGS_ERROR';

const UPDATE_BLOG_REQUEST = 'app/AIUpdateListingPage/UPDATE_BLOG_REQUEST';
const UPDATE_BLOG_SUCCESS = 'app/AIUpdateListingPage/UPDATE_BLOG_SUCCESS';
const UPDATE_BLOG_ERROR = 'app/AIUpdateListingPage/UPDATE_BLOG_ERROR';

const DELETE_BLOG_REQUEST = 'app/AIUpdateListingPage/DELETE_BLOG_REQUEST';
const DELETE_BLOG_SUCCESS = 'app/AIUpdateListingPage/DELETE_BLOG_SUCCESS';
const DELETE_BLOG_ERROR = 'app/AIUpdateListingPage/DELETE_BLOG_ERROR';

const PUBLISH_BLOG_REQUEST = 'app/AIUpdateListingPage/PUBLISH_BLOG_REQUEST';
const PUBLISH_BLOG_SUCCESS = 'app/AIUpdateListingPage/PUBLISH_BLOG_SUCCESS';
const PUBLISH_BLOG_ERROR = 'app/AIUpdateListingPage/PUBLISH_BLOG_ERROR';

const SET_DELETED_IMAGE_IDS = 'app/AIUpdateListingPage/SET_DELETED_IMAGE_IDS';

const sortExceptionsByStartTime = (a, b) => {
    return a.attributes.start.getTime() - b.attributes.start.getTime();
  };

// ================ Reducer ================ //

const initialState = {
    listing: null,

    // Blog-related state
    blogs: [], // array of blog objects
    fetchBlogsInProgress: false,
    fetchBlogsError: null,
    analytics: {},

    updateBlogInProgress: {}, // { [blogId]: boolean }
    updateBlogError: {},      // { [blogId]: error }
    deleteBlogInProgress: {}, // { [blogId]: boolean }
    
    deleteBlogError: {},      // { [blogId]: error }
    publishBlogInProgress: {}, // { [blogId]: boolean }
    publishBlogError: {},      // { [blogId]: error }

    // Blog titles state
    blogTitleswithLabels: [],
    blogTitleswithLabelsInProgress: false,
    blogTitleswithLabelsError: null,

    credits: {},
    creditsLoading: false,
    creditsError: null,
    listingRequested: false,
    listingError: null,
    weeklyExceptionQueries: {
        // '2022-12-12': { // Note: id/key is the start of the week in given time zone
        //   fetchExceptionsError: null,
        //   fetchExceptionsInProgress: null,
        // },
    },
    monthlyExceptionQueries: {
        // '2022-12': {
        //   fetchExceptionsError: null,
        //   fetchExceptionsInProgress: null,
        // },
    },
    AIGeneratedImages: null,
    AIGeneratedImagesRequested: false,
    AIGeneratedImagesError: null,
    
    enhanceFieldInProgress: {},
    enhanceFieldError: {},
    enhancedField: {},

    updateListingInProgress: false,
    updateListingError: null,

    publishListingInProgress: false,
    publishListingError: null,

    allExceptions: [],
    addExceptionError: null,
    addExceptionInProgress: false,
    deleteExceptionError: null,
    deleteExceptionInProgress: false,

    generatedImages: [],
    generateImagesError: null,
    generateImagesInProgress: false,

    generateBlogsInProgress: false,
    generateBlogsError: null,

    deletedImageIds: [],
    
};

// ================ Reducer ================ //

const AIUpdateListingPageReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_CREDITS_REQUEST:
            return { ...state, creditsLoading: true, creditsError: null };
        case GET_CREDITS_SUCCESS:
            return { ...state, creditsLoading: false, credits: payload, creditsError: null };
        case GET_CREDITS_ERROR:
            return { ...state, creditsLoading: false, creditsError: payload };
        case FETCH_LISITNG_REQUESTED:
            return { ...state, listingRequested: true };
        case FETCH_LISTING_SUCCESS:
            return { ...state, listing: payload, listingRequested: false };
        case FETCH_LISTING_ERROR:
            return { ...state, listing: null, listingRequested: false, listingError: payload };
        case FETCH_EXCEPTIONS_REQUEST: {
            const { monthId, weekStartId } = payload.params;
            const newData = {
                fetchExceptionsError: null,
                fetchExceptionsInProgress: true,
            };

            const exceptionQueriesMaybe = monthId
                ? mergeToMonthlyExceptionQueries(
                    state.monthlyExceptionQueries,
                    monthId,
                    newData
                )
                : weekStartId
                    ? mergeToWeeklyExceptionQueries(
                        state.weeklyExceptionQueries,
                        weekStartId,
                        newData
                    )
                    : {};
            return { ...state, ...exceptionQueriesMaybe };
        }
        case FETCH_EXCEPTIONS_SUCCESS: {
            const { exceptions, monthId, weekStartId } = payload;
            const combinedExceptions = state.allExceptions.concat(exceptions);
            const selectId = x => x.id.uuid;
            const allExceptions = uniqueBy(combinedExceptions, selectId).sort(
                sortExceptionsByStartTime
            );
            const newData = { fetchExceptionsInProgress: false };

            const exceptionQueriesMaybe = monthId
                ? mergeToMonthlyExceptionQueries(
                    state.monthlyExceptionQueries,
                    monthId,
                    newData
                )
                : weekStartId
                    ? mergeToWeeklyExceptionQueries(
                        state.weeklyExceptionQueries,
                        weekStartId,
                        newData
                    )
                    : {};
            return { ...state, allExceptions, ...exceptionQueriesMaybe };
        }
        case FETCH_EXCEPTIONS_ERROR: {
            const { monthId, weekStartId, error } = payload;
            const newData = {
                fetchExceptionsInProgress: false,
                fetchExceptionsError: error,
            };

            const exceptionQueriesMaybe = monthId
                ? mergeToMonthlyExceptionQueries(
                    state.monthlyExceptionQueries,
                    monthId,
                    newData
                )
                : weekStartId
                    ? mergeToWeeklyExceptionQueries(
                        state.weeklyExceptionQueries,
                        weekStartId,
                        newData
                    )
                    : {};

            return { ...state, ...exceptionQueriesMaybe };
        }
        case AIGENERATED_IMAGES_REQUESTED:
            return { ...state, AIGeneratedImagesRequested: true };
        case AIGENERATED_IMAGES_SUCCESS:
            return { ...state, AIGeneratedImagesRequested: false, AIGeneratedImages: payload };
        case AIGENERATED_IMAGES_ERROR:
            return { ...state, AIGeneratedImagesRequested: false, AIGeneratedImages: null, AIGeneratedImagesError: payload };

        case ENHANCE_FIELD_REQUEST:
            return { ...state, enhanceFieldInProgress: { ...state.enhanceFieldInProgress, [payload.field]: true } };
        case ENHANCE_FIELD_SUCCESS:
            return {
                ...state,
                enhanceFieldInProgress: { ...state.enhanceFieldInProgress, [payload.field]: false },
                enhancedField: { ...state.enhancedField, [payload.field]: payload.data }
            };
        case ENHANCE_FIELD_ERROR:
            return {
                ...state,
                enhanceFieldInProgress: { ...state.enhanceFieldInProgress, [payload.field]: false },
                enhanceFieldError: { ...state.enhanceFieldError, [payload.field]: payload.error }
            };

        case UPDATE_LISTING_REQUEST:
            return { ...state, updateListingInProgress: true };
        case UPDATE_LISTING_SUCCESS:
            return { ...state, updateListingInProgress: false, updateListingError: null };
        case UPDATE_LISTING_ERROR:
            return { ...state, updateListingInProgress: false, updateListingError: payload };

        case PUBLISH_LISTING_REQUEST:
            return { ...state, publishListingInProgress: true };
        case PUBLISH_LISTING_SUCCESS:
            return { ...state, publishListingInProgress: false, publishListingError: null };
        case PUBLISH_LISTING_ERROR:
            return { ...state, publishListingInProgress: false, publishListingError: payload };

        case ADD_AVAILABILITY_EXCEPTION_REQUEST:
            return {
                ...state,
                addExceptionError: null,
                addExceptionInProgress: true,
            };
        case ADD_AVAILABILITY_EXCEPTION_SUCCESS: {
            const exception = payload;
            const combinedExceptions = state.allExceptions.concat(exception);
            const allExceptions = combinedExceptions.sort(sortExceptionsByStartTime);
            return {
                ...state,
                allExceptions,
                addExceptionInProgress: false,
            };
        }
        case ADD_AVAILABILITY_EXCEPTION_ERROR:
            return {
                ...state,
                addExceptionError: payload.error,
                addExceptionInProgress: false,
            };

        case DELETE_AVAILABILITY_EXCEPTION_REQUEST:
            return {
                ...state,
                deleteExceptionError: null,
                deleteExceptionInProgress: true,
            };
        case DELETE_AVAILABILITY_EXCEPTION_SUCCESS: {
            const exception = payload;
            const id = exception.id.uuid;
            const allExceptions = state.allExceptions.filter(e => e.id.uuid !== id);
            return {
                ...state,
                allExceptions,
                deleteExceptionInProgress: false,
            };
        }
        case DELETE_AVAILABILITY_EXCEPTION_ERROR:
            return {
                ...state,
                deleteExceptionError: payload.error,
                deleteExceptionInProgress: false,
            };

        case FETCH_EXTRA_EXCEPTIONS_SUCCESS: {
              const combinedExceptions = state.allExceptions.concat(payload.exceptions);
              const selectId = x => x.id.uuid;
              const allExceptions = uniqueBy(combinedExceptions, selectId).sort(
                sortExceptionsByStartTime
              );
              // TODO: currently we don't handle thrown errors from these paginated calls
              return { ...state, allExceptions };
            }

        case GENERATE_AI_IMAGES_REQUEST:
            return {
                ...state,
                generateImagesInProgress: true,
                generateImagesError: null,
            };
        case GENERATE_AI_IMAGES_SUCCESS:
            return {
                ...state,
                generateImagesInProgress: false,
                generateImagesError: null,
                generatedImages: [...state.generatedImages, ...payload],
            };
        case GENERATE_AI_IMAGES_ERROR:
            return {
                ...state,
                generateImagesInProgress: false,
                generateImagesError: payload,
            };

        case GENERATE_BLOG_TITLES_REQUEST:
            return { ...state, blogTitleswithLabelsInProgress: true, blogTitleswithLabelsError: null };
        case GENERATE_BLOG_TITLES_SUCCESS:
            return { ...state, blogTitleswithLabelsInProgress: false, blogTitleswithLabels: action.payload };
        case GENERATE_BLOG_TITLES_ERROR:
            return { ...state, blogTitleswithLabelsInProgress: false, blogTitleswithLabelsError: action.error };
        
        case GENERATE_BLOGS_REQUEST:
            return { ...state, generateBlogsInProgress: true, generateBlogsError: null };
        case GENERATE_BLOGS_SUCCESS:
            return { ...state, generateBlogsInProgress: false, generateBlogsError: null };
        case GENERATE_BLOGS_ERROR:
            return { ...state, generateBlogsInProgress: false, generateBlogsError: action.error };

        // BLOGS REDUCER LOGIC
        case FETCH_BLOGS_REQUEST:
            return { ...state, fetchBlogsInProgress: true, fetchBlogsError: null };
        case FETCH_BLOGS_SUCCESS:
            return { ...state, fetchBlogsInProgress: false, fetchBlogsError: null, blogs: payload.blogs, analytics: payload.analytics };
        case FETCH_BLOGS_ERROR:
            return { ...state, fetchBlogsInProgress: false, fetchBlogsError: payload.error };

        case UPDATE_BLOG_REQUEST:
            return {
                ...state,
                updateBlogInProgress: { ...state.updateBlogInProgress, [payload.id]: true },
                updateBlogError: { ...state.updateBlogError, [payload.id]: null },
            };
        case UPDATE_BLOG_SUCCESS:
            return {
                ...state,
                updateBlogInProgress: { ...state.updateBlogInProgress, [payload.blog._id]: false },
                updateBlogError: { ...state.updateBlogError, [payload.blog._id]: null },
                blogs: state.blogs.map(b => b._id === payload.blog._id ? payload.blog : b),
            };
        case UPDATE_BLOG_ERROR:
            return {
                ...state,
                updateBlogInProgress: { ...state.updateBlogInProgress, [payload.id]: false },
                updateBlogError: { ...state.updateBlogError, [payload.id]: payload.error },
            };

        case DELETE_BLOG_REQUEST:
            return {
                ...state,
                deleteBlogInProgress: { ...state.deleteBlogInProgress, [payload.id]: true },
                deleteBlogError: { ...state.deleteBlogError, [payload.id]: null },
            };
        case DELETE_BLOG_SUCCESS:
            return {
                ...state,
                deleteBlogInProgress: { ...state.deleteBlogInProgress, [payload.id]: false },
                deleteBlogError: { ...state.deleteBlogError, [payload.id]: null },
                blogs: state.blogs.filter(b => b._id !== payload.id),
            };
        case DELETE_BLOG_ERROR:
            return {
                ...state,
                deleteBlogInProgress: { ...state.deleteBlogInProgress, [payload.id]: false },
                deleteBlogError: { ...state.deleteBlogError, [payload.id]: payload.error },
            };

        case PUBLISH_BLOG_REQUEST:
            return {
                ...state,
                publishBlogInProgress: { ...state.publishBlogInProgress, [payload.id]: true },
                publishBlogError: { ...state.publishBlogError, [payload.id]: null },
            };
        case PUBLISH_BLOG_SUCCESS:
            return {
                ...state,
                publishBlogInProgress: { ...state.publishBlogInProgress, [payload.blog._id]: false },
                publishBlogError: { ...state.publishBlogError, [payload.blog._id]: null },
                blogs: state.blogs.map(b => b._id === payload.blog._id ? payload.blog : b),
            };
        case PUBLISH_BLOG_ERROR:
            return {
                ...state,
                publishBlogInProgress: { ...state.publishBlogInProgress, [payload.id]: false },
                publishBlogError: { ...state.publishBlogError, [payload.id]: payload.error },
            };

        case SET_DELETED_IMAGE_IDS:
            return {
                ...state,
                deletedImageIds: [...state.deletedImageIds, payload],
            }
        default:
            return state;
    }
};

export default AIUpdateListingPageReducer;


// ================ Action creators ================ //

const requestAction = actionType => params => ({
    type: actionType,
    payload: { params },
});

const successAction = actionType => result => ({
    type: actionType,
    payload: result.data,
});

const errorAction = actionType => payload => ({
    type: actionType,
    payload,
    error: true,
});

export const AIgeneratedImagesRequest = () => ({
    type: AIGENERATED_IMAGES_REQUESTED
});

export const AIgeneratedImagesSuccess = (payload) => ({
    type: AIGENERATED_IMAGES_SUCCESS,
    payload: payload
});

export const AIgeneratedImagesError = (payload) => ({
    type: AIGENERATED_IMAGES_ERROR,
    payload: payload
});

export const showListingsRequest = () => ({
    type: FETCH_LISITNG_REQUESTED
});

export const showListingsSuccess = (payload) => ({
    type: FETCH_LISTING_SUCCESS,
    payload: payload
});

export const showListingsError = (payload) => ({
    type: FETCH_LISTING_ERROR,
    payload: payload
});

// SDK method: availabilityExceptions.query
export const fetchAvailabilityExceptionsRequest = requestAction(
    FETCH_EXCEPTIONS_REQUEST
);
export const fetchAvailabilityExceptionsSuccess = successAction(
    FETCH_EXCEPTIONS_SUCCESS
);
export const fetchAvailabilityExceptionsError = errorAction(
    FETCH_EXCEPTIONS_ERROR
);

export const updateListingRequest = _ => ({
    type: UPDATE_LISTING_REQUEST
});

export const updateListingSuccess = _ => ({
    type: UPDATE_LISTING_SUCCESS
});

export const updateListingError = error => ({
    type: UPDATE_LISTING_ERROR,
    payload: error
});

export const publishListingRequest = () => ({
    type: PUBLISH_LISTING_REQUEST
});

export const publishListingSuccess = () => ({
    type: PUBLISH_LISTING_SUCCESS
});

export const publishListingError = error => ({
    type: PUBLISH_LISTING_ERROR,
    payload: error
});


export const getCreditsRequest = () => ({ type: GET_CREDITS_REQUEST });
export const getCreditsSuccess = payload => ({ type: GET_CREDITS_SUCCESS, payload });
export const getCreditsError = error => ({ type: GET_CREDITS_ERROR, payload: error });

export const enhanceFieldRequest = field => ({ type: ENHANCE_FIELD_REQUEST, payload: { field } });
export const enhanceFieldSuccess = (field, enhancedContent) => ({ type: ENHANCE_FIELD_SUCCESS, payload: { field, data: enhancedContent[field] } });
export const enhanceFieldError = (field, error) => ({ type: ENHANCE_FIELD_ERROR, payload: { field, error } });

export const addAvailabilityExceptionRequest = () => ({ type: ADD_AVAILABILITY_EXCEPTION_REQUEST });
export const addAvailabilityExceptionSuccess = (payload) => ({ type: ADD_AVAILABILITY_EXCEPTION_SUCCESS, payload });
export const addAvailabilityExceptionError = (payload) => ({ type: ADD_AVAILABILITY_EXCEPTION_ERROR, payload });

export const deleteAvailabilityExceptionRequest = () => ({ type: DELETE_AVAILABILITY_EXCEPTION_REQUEST });
export const deleteAvailabilityExceptionSuccess = (payload) => ({ type: DELETE_AVAILABILITY_EXCEPTION_SUCCESS, payload });
export const deleteAvailabilityExceptionError = (payload) => ({ type: DELETE_AVAILABILITY_EXCEPTION_ERROR, payload });

// Add extra data from additional pages
export const fetchExtraAvailabilityExceptionsSuccess = successAction(
  FETCH_EXTRA_EXCEPTIONS_SUCCESS
);

export const generateAIImagesRequest = () => ({ type: GENERATE_AI_IMAGES_REQUEST });
export const generateAIImagesSuccess = (data) => ({ type: GENERATE_AI_IMAGES_SUCCESS, payload: data });
export const generateAIImagesError = (error) => ({ type: GENERATE_AI_IMAGES_ERROR, payload: storableError(error) });

export const generateBlogTitlesRequest = () => ({ type: GENERATE_BLOG_TITLES_REQUEST });
export const generateBlogTitlesSuccess = titles => ({ type: GENERATE_BLOG_TITLES_SUCCESS, payload: titles });
export const generateBlogTitlesError = error => ({ type: GENERATE_BLOG_TITLES_ERROR, error });

export const generateBlogsRequest = () => ({ type: GENERATE_BLOGS_REQUEST });
export const generateBlogsSuccess = blogs => ({ type: GENERATE_BLOGS_SUCCESS, payload: blogs });
export const generateBlogsError = error => ({ type: GENERATE_BLOGS_ERROR, error });

const fetchBlogsRequest = () => ({ type: FETCH_BLOGS_REQUEST });
const fetchBlogsSuccess = ({ blogs, analytics }) => ({ type: FETCH_BLOGS_SUCCESS, payload: { blogs, analytics } });
const fetchBlogsError = error => ({ type: FETCH_BLOGS_ERROR, payload: { error } });

const updateBlogRequest = id => ({ type: UPDATE_BLOG_REQUEST, payload: { id } });
const updateBlogSuccess = blog => ({ type: UPDATE_BLOG_SUCCESS, payload: { blog } });
const updateBlogError = (id, error) => ({ type: UPDATE_BLOG_ERROR, payload: { id, error } });

const deleteBlogRequest = id => ({ type: DELETE_BLOG_REQUEST, payload: { id } });
const deleteBlogSuccess = id => ({ type: DELETE_BLOG_SUCCESS, payload: { id } });
const deleteBlogError = (id, error) => ({ type: DELETE_BLOG_ERROR, payload: { id, error } });

const publishBlogRequest = id => ({ type: PUBLISH_BLOG_REQUEST, payload: { id } });
const publishBlogSuccess = blog => ({ type: PUBLISH_BLOG_SUCCESS, payload: { blog } });
const publishBlogError = (id, error) => ({ type: PUBLISH_BLOG_ERROR, payload: { id, error } });

export const setDeletedImageIds = ({ sharetribeImgId, cloudinaryPublicId }) => ({ type: SET_DELETED_IMAGE_IDS, payload: { sharetribeImgId, cloudinaryPublicId } });

// ================ Thunks ================ //

export const requestGetCredits = (listingToken) => async (dispatch) => {
    try {
        dispatch(getCreditsRequest());
        const credits = await getCredits(listingToken);
        dispatch(getCreditsSuccess(credits.remainingCredits));
    } catch (error) {
        dispatch(getCreditsError(error));
    }
};

export const requestAIToGenerateImages = params => (dispatch, getState, sdk) => {

    const { listingId, AIGeneratedImages = [], ...rest } = params;

    try {
        dispatch(AIgeneratedImagesRequest());

        return generateAIImages(rest).then(async response => {
            const { images = [] } = response;

            let imageResults = [];

            if (images && images.length) {
                const files = images.map(img => base64ToFile(img.base64Image, `listing-img-${uuid4()}`));
                imageResults = await Promise.all(files.map(async (file, index) => {

                    // Upload to Sharetribe
                    const imgRes = await sdk.images.upload({ image: file });

                    // Use the existing Cloudinary data from the backend
                    const cloudinaryData = images[index];

                    return {
                        id: imgRes.data.data.id.uuid,
                        imageUrl: cloudinaryData.imageUrl,
                        publicId: cloudinaryData.publicId,
                        height: cloudinaryData.height,
                        width: cloudinaryData.width,
                        metadata: cloudinaryData.metadata
                    };
                }));
            }

            // need to update the listing, and the data from the images
            dispatch(updateOwnListing({
                listingId: listingId,
                publicData: {
                    aIGeneratedImagesData: [...AIGeneratedImages, ...imageResults]
                }
            }));

            dispatch(AIgeneratedImagesSuccess(imageResults));

            return imageResults;
        });
    } catch (error) {
        return dispatch(AIgeneratedImagesError(error));
    }
};

export const requestAddAvailabilityException = params => (
  dispatch,
  getState,
  sdk
) => {
  dispatch(addAvailabilityExceptionRequest(params));

  return sdk.availabilityExceptions
    .create(params, { expand: true })
    .then(response => {
      const availabilityException = response.data.data;
      return dispatch(
        addAvailabilityExceptionSuccess({ data: availabilityException })
      );
    })
    .catch(e => {
      dispatch(addAvailabilityExceptionError({ error: storableError(e) }));
      throw e;
    });
};

export const requestDeleteAvailabilityException = params => (
  dispatch,
  getState,
  sdk
) => {
  dispatch(deleteAvailabilityExceptionRequest(params));

  return sdk.availabilityExceptions
    .delete(params, { expand: true })
    .then(response => {
      const availabilityException = response.data.data;
      return dispatch(
          deleteAvailabilityExceptionSuccess(availabilityException)
      );
    })
    .catch(e => {
      dispatch(deleteAvailabilityExceptionError({ error: storableError(e) }));
      throw e;
    });
};

export const requestFetchAvailabilityExceptions = params => (
    dispatch,
    getState,
    sdk
) => {
    const { listingId, start, end, timeZone, page, isWeekly } = params;
    const fetchParams = { listingId, start, end };
    const timeUnitIdProp = isWeekly
        ? { weekStartId: stringifyDateToISO8601(start) }
        : { monthId: monthIdString(start, timeZone) };
    dispatch(fetchAvailabilityExceptionsRequest(timeUnitIdProp));

    return sdk.availabilityExceptions
        .query(fetchParams)
        .then(response => {
            const availabilityExceptions = denormalisedResponseEntities(response);

            // Fetch potential extra exceptions pagination pages per month.
            // In theory, there could be several pagination pages worth of exceptions,
            // if range is month and unit is 'hour': 31 days * 24 hour = 744 slots for exceptions.
            const totalPages = response.data.meta.totalPages;
            if (totalPages > 1 && !page) {
                const extraPages = getArrayOfNItems(totalPages);

                // It's unlikely that this code is reached with default units.
                // Note:
                //  - Firing multiple API calls might hit API rate limit
                //    (This is very unlikely with this query and 'hour' unit.)
                //  - TODO: this doesn't take care of failures of those extra calls
                Promise.all(
                    extraPages.map(page => {
                        return sdk.availabilityExceptions.query({ ...fetchParams, page });
                    })
                ).then(responses => {
                    const denormalizedFlatResults = (all, r) =>
                        all.concat(denormalisedResponseEntities(r));
                    const exceptions = responses.reduce(denormalizedFlatResults, []);
                    dispatch(
                        fetchExtraAvailabilityExceptionsSuccess({
                            data: { ...timeUnitIdProp, exceptions },
                        })
                    );
                });
            }

            return dispatch(
                fetchAvailabilityExceptionsSuccess({
                    data: { ...timeUnitIdProp, exceptions: availabilityExceptions },
                })
            );
        })
        .catch(e => {
            return dispatch(
                fetchAvailabilityExceptionsError({
                    ...timeUnitIdProp,
                    error: storableError(e),
                })
            );
        });
};

// Helper function for loadData call.
const fetchLoadDataExceptions = (dispatch, listing, search, firstDayOfWeek = 1) => {
    const hasWindow = typeof window !== 'undefined';
    // Listing could be ownListing entity too, so we just check if attributes key exists
    const hasTimeZone = listing?.attributes?.availabilityPlan?.timezone;

    // Fetch time-zones on client side only.
    // Note: listing needs to have time zone set!
    if (hasWindow && listing.id && hasTimeZone) {
        const listingId = listing.id;
        // If the listing doesn't have availabilityPlan yet
        // use the defaul timezone
        const timezone =
            listing.attributes.availabilityPlan?.timezone ||
            getDefaultTimeZoneOnBrowser();
        const todayInListingsTZ = getStartOf(new Date(), 'day', timezone);

        const locationSearch = parse(search);
        const selectedDate = locationSearch?.d
            ? parseDateFromISO8601(locationSearch.d, timezone)
            : todayInListingsTZ;
        const startOfWeek = getStartOfWeek(selectedDate, timezone, firstDayOfWeek);
        const prevWeek = getStartOf(startOfWeek, 'day', timezone, -7, 'days');
        const nextWeek = getStartOf(startOfWeek, 'day', timezone, 7, 'days');
        const nextAfterNextWeek = getStartOf(nextWeek, 'day', timezone, 7, 'days');

        const nextMonth = getStartOf(
            todayInListingsTZ,
            'month',
            timezone,
            1,
            'months'
        );
        const nextAfterNextMonth = getStartOf(
            nextMonth,
            'month',
            timezone,
            1,
            'months'
        );

        const sharedData = { listingId, timeZone: timezone };

        // Fetch data for selected week and nearest weeks for WeeklyCalendar
        // Plus current month and month after that for EditListingAvailabilityForm
        //
        // NOTE: This is making 5 different Thunk calls, which update store 2 times each
        //       It would make sense to make on thunk function that fires 5 sdk calls/promises,
        //       but for the time being, it's clearer to push all the calls through
        //       requestFetchAvailabilityExceptions
        return Promise.all([
            dispatch(
                requestFetchAvailabilityExceptions({
                    ...sharedData,
                    isWeekly: true,
                    start: prevWeek,
                    end: startOfWeek,
                })
            ),
            dispatch(
                requestFetchAvailabilityExceptions({
                    ...sharedData,
                    isWeekly: true,
                    start: startOfWeek,
                    end: nextWeek,
                })
            ),
            dispatch(
                requestFetchAvailabilityExceptions({
                    ...sharedData,
                    isWeekly: true,
                    start: nextWeek,
                    end: nextAfterNextWeek,
                })
            ),
            dispatch(
                requestFetchAvailabilityExceptions({
                    ...sharedData,
                    start: todayInListingsTZ,
                    end: nextMonth,
                })
            ),
            dispatch(
                requestFetchAvailabilityExceptions({
                    ...sharedData,
                    start: nextMonth,
                    end: nextAfterNextMonth,
                })
            ),
        ]);
    }

    // By default return an empty array
    return Promise.all([]);
};

// fetch the listing, with it's data as it is own listing.
export const requestShowListing = (actionPayload, config) => (dispatch, getState, sdk) => {
    const imageVariantInfo = getImageVariantInfo(config.layout.listingImage);
    const queryParams = {
        include: ['author', 'images', 'currentStock', 'publicData'],
        'fields.image': imageVariantInfo.fieldsImage,
        ...imageVariantInfo.imageVariants,
    };

    dispatch(showListingsRequest());
    return sdk.ownListings
        .show({ ...actionPayload, ...queryParams })
        .then(response => {
            // EditListingPage fetches new listing data, which also needs to be added to global data
            dispatch(addMarketplaceEntities(response));
            // In case of success, we'll clear state.EditListingPage (user will be redirected away)
            const denormalizedResponse = denormalisedResponseEntities(response);
            dispatch(showListingsSuccess(denormalizedResponse[0]));
            return response;
        })
        .catch(e => dispatch(showListingsError(storableError(e))));
};



export const requestEnhanceField = (enhanceFieldParams) => async (dispatch, getState, sdk) => {
    try {
        dispatch(enhanceFieldRequest(enhanceFieldParams.fieldName));
        const { data } = await enhanceField(enhanceFieldParams);
        const remainingCredits = data.remainingCredits;

        dispatch(enhanceFieldSuccess(data.fieldName, data.enhancedContent));
        dispatch(getCreditsSuccess(remainingCredits));

        return {
            fieldName: data.fieldName,
            enhancedContent: data.enhancedContent
        };
    } catch (error) {
        dispatch(enhanceFieldError(enhanceFieldParams.fieldName, error));
        throw error;
    }
};

const processImages = async (images, sdk) => {
    // Upload images to sharetribe and cloudinary
    // Only fresh images will be uploaded to cloudinary
    // May include fresh images and generated images
    // Some generated images may have base64 data other will have
    // a cloudinary url, we need to convert them to file before
    // uploading to sharetribe.
    // The first image is cover photo, you need to keep that at first in the listing images and sharetribe

    // Store results with their original index
    let firstImagePublicId = null;
    let firstImageSharetribeId = null;
    const uploadResults = [];
    if (images && images.length > 0) {
        const allUploadPromises = images.map((image, idx) => {
            // File image
            if (image instanceof File) {
                return (async () => {
                    const uploadRes = await sdk.images.upload({ image });
                    const id = uploadRes.data.data.id.uuid;
                    // Upload to cloudinary
                    const result = await UploadImage({ file: image, id });
                    if (!result || !result.secure_url) {
                        throw new Error('Image upload failed');
                    }
                    uploadResults[idx] = {
                        public_id: result.public_id,
                        secure_url: result.secure_url,
                        height: result.height,
                        width: result.width,
                        sharetribeImgId: id,
                    };
                    if (idx === 0) {
                        firstImagePublicId = result.public_id;
                        firstImageSharetribeId = id;
                    }
                    return id;
                })();
            }
            // Base64 image
            else if (image.base64Image) {
                return (async () => {
                    const file = base64ToFile(image.base64Image, `listing-img-${uuid4()}`);
                    const uploadRes = await sdk.images.upload({ image: file });
                    const id = uploadRes.data.data.id.uuid;
                    uploadResults[idx] = {
                        public_id: image.public_id,
                        secure_url: image.secure_url,
                        height: image.height,
                        width: image.width,
                        sharetribeImgId: id,
                    };
                    if (idx === 0) {
                        firstImagePublicId = image.public_id;
                        firstImageSharetribeId = id;
                    }
                    return id;
                })();
            }
            // Cloudinary image
            else if (image.newGenerated && !image.base64Image && image.secure_url) {
                return (async () => {
                    const file = await urlToFile(image.secure_url, image.public_id, image.mimeType || 'image/jpeg');
                    const uploadRes = await sdk.images.upload({ image: file });
                    const id = uploadRes.data.data.id.uuid;
                    uploadResults[idx] = {
                        public_id: image.public_id,
                        secure_url: image.secure_url,
                        height: image.height,
                        width: image.width,
                        sharetribeImgId: id,
                    };
                    if (idx === 0) {
                        firstImagePublicId = image.public_id;
                        firstImageSharetribeId = id;
                    }
                    return id;
                })();
            }
            // Fallback (should not happen)
            else {
                if (idx === 0) {
                    firstImagePublicId = image.public_id;
                    firstImageSharetribeId = image.sharetribeImgId;
                }
                uploadResults[idx] = null;
                return Promise.resolve(null);
            }
        });
        const sharetribeImageIds = await Promise.all(allUploadPromises);
        // Filter out any nulls (if any image failed to process)
        const listingImages = uploadResults.filter(Boolean);
        const validSharetribeImageIds = sharetribeImageIds.filter(Boolean);
        return {
            listingImages,
            sharetribeImageIds: validSharetribeImageIds,
            firstImagePublicId,
            firstImageSharetribeId
        };
    }
    return {
        listingImages: [],
        sharetribeImageIds: []
    };
};

export function requestUpdateListing(data, config) {
  return async (dispatch, getState, sdk) => {
    dispatch(updateListingRequest(data));
    const { id, images, publicData, availabilityExceptions, ...rest } = data;
    const applicationState = getState();

    // Process images
    // This will upload images to sharetribe and cloudinary
      const { listingImages = [], sharetribeImageIds = [], firstImagePublicId, firstImageSharetribeId } = await processImages(images, sdk);


    const deletedImageIds = applicationState.AIUpdateListingPage.deletedImageIds;
    const deletedCloudinaryPublicIds = deletedImageIds.map(id => id.cloudinaryPublicId);
    const deletedSharetribeImageIds = deletedImageIds.map(id => id.sharetribeImgId);
   

    // Instruction video maybe 
      if (publicData?.instructions?.video instanceof File) {
          const videoFile = publicData.instructions.video;
          const uploadRes = await UploadVideo({
              file: videoFile,
              id: uuid4(),
          });

          publicData.instructions.video = {
              public_id: uploadRes.public_id,
              asset_id: uploadRes.asset_id,
              width: uploadRes.width,
              height: uploadRes.height,
              playback_url: uploadRes.playback_url,
          };
      };

      // Get existing images
      const currentListing = applicationState.AIUpdateListingPage.listing;
      
      const currentListingPublicData = currentListing?.attributes?.publicData;
      const existingImages = currentListingPublicData?.listingImages || [];
      const existingImagesIds = currentListing?.images?.map(img => img.id.uuid) || [];

      const allListingImages = [...existingImages, ...listingImages];
      let filteredListingImages = allListingImages.filter(img => !deletedCloudinaryPublicIds.includes(img.public_id));
    
      const allSharetribeIds = [...existingImagesIds, ...sharetribeImageIds];
      let filteredSharetribeImageIds = allSharetribeIds.filter(id => !deletedSharetribeImageIds.includes(id));
    
      //   Place first images and ids at first place
      //  The first image is a cover photo.
      if (firstImagePublicId && firstImageSharetribeId) {
          // first remove than add at first place
          const idx = filteredListingImages.findIndex(img => img.public_id === firstImagePublicId);
          const removedImage = filteredListingImages.splice(idx, 1)[0];
          filteredListingImages.unshift(removedImage);

          const idx2 = filteredSharetribeImageIds.findIndex(id => id === firstImageSharetribeId);
          const removedSharetribeId = filteredSharetribeImageIds.splice(idx2, 1)[0];
          filteredSharetribeImageIds.unshift(removedSharetribeId);
      };

      const updatedPublicData = {
          ...publicData,
          listingImages: filteredListingImages,
      };

    const ownListingUpdateValues = {
      id,
      images: filteredSharetribeImageIds,
      publicData: updatedPublicData,
      ...rest,
    };

    const imageVariantInfo = getImageVariantInfo(config.layout.listingImage);
    const queryParams = {
        expand: true,
        include: ['author', 'images', 'currentStock', 'publicData'],
        'fields.image': imageVariantInfo.fieldsImage,
        ...imageVariantInfo.imageVariants,
    };

    const { currentUser } = applicationState.user;
    const { email } = currentUser.attributes;

    const {
      firstName,
      lastName,
      displayName,
      publicData: userPublicData,
    } = currentUser.attributes.profile;

    const existingTimeZone =
      applicationState.marketplaceData.entities.ownListing[id]?.attributes
        ?.availabilityPlan?.timezone;
    const includedTimeZone = rest?.availabilityPlan?.timezone;

    // Note: if update values include stockUpdate, we'll do that first
    // That way we get updated currentStock info among ownListings.update

    return sdk.ownListings.update(ownListingUpdateValues, queryParams)
      .then(response => {
        dispatch(updateListingSuccess(response));
        const denormalisedResponse = denormalisedResponseEntities(response)[0];
        dispatch(showListingsSuccess(denormalisedResponse));
        dispatch(addMarketplaceEntities(response));
        const filteredAvailabilityExceptions = availabilityExceptions.filter(exception => exception.start  && exception.end);
        if (filteredAvailabilityExceptions && filteredAvailabilityExceptions.length > 0) {
            Promise.all(
                filteredAvailabilityExceptions.map(exception =>
                    sdk.availabilityExceptions.create({
                        listingId: id,
                        start: new Date(exception.start),
                        end: new Date(exception.end),
                        seats: exception.seats,
                    })
                )
            )
            .then(() => {
                fetchLoadDataExceptions(dispatch, denormalisedResponse);
            })
        };

        // Save to Algolia
        const {
          title = '',
          description = '',
          price,
          state,
          geolocation,
          availabilityPlan = '',
          createdAt,
          publicData = {},
          metadata = {},
        } = response.data.data.attributes || {};

        if (state == 'published') {
          createAlgoliaData({
            indexName: process.env.REACT_APP_ALGOLIA_LISTINGS_INDEX,
            objectID: id,
            state,
            _geoloc:
              geolocation && geolocation.lat
                ? { lat: geolocation.lat, lng: geolocation.lng }
                : {},
            title,
            description: description.slice(0, 999),
            price,
            availabilityPlan,
            publicData: {
              ...filterPublicDataToAlgolia(publicData, LISTING_ALOGLIA_REMOVABLE_FIELDS),
            },
            metadata,
            user: {
              id: currentUser.id.uuid,
              firstName,
              lastName,
              email,
              displayName,
              publicData: omit(userPublicData, LISTING_USER_PUBLIC_DATA_REMOVABLE_FIELDS),
            },
            createdAt,
            timestamp: moment(createdAt).unix(),
            order: publicData.order,
          });
        }

        // If time zone has changed, we need to fetch exceptions again
        // since week and month boundaries might have changed.
        if (!!includedTimeZone && includedTimeZone !== existingTimeZone) {
          const searchString = '';
          const firstDayOfWeek = config.localization.firstDayOfWeek;
          const listing = response.data.data;
          fetchLoadDataExceptions(
            dispatch,
            listing,
            searchString,
            firstDayOfWeek
          );
        }

        return response;
      })
      .catch(e => {
        console.error(e, 'update-listing-failed', { listingData: data });
        return dispatch(updateListingError(storableError(e)));
      });
  };
};

export const requestPublishListingDraft = listingId => (
  dispatch,
  getState,
  sdk
) => {
  // Log the listing ID and its type for debugging
  console.log(
    'Publishing listing with ID:',
    listingId,
    'Type:',
    typeof listingId
  );

  // Ensure listingId is a string
  const id = listingId?.uuid || listingId;
  console.log('Using listing ID for publish:', id);

  dispatch(publishListingRequest(id));

  // Log the SDK method being called
  console.log(
    'Calling sdk.ownListings.publishDraft with:',
    { id },
    { expand: true }
  );

  return sdk.ownListings
    .publishDraft({ id }, { expand: true })
    .then(response => {
      // Add the created listing to the marketplace data
      dispatch(addMarketplaceEntities(response));
      dispatch(publishListingSuccess(response));

      // Save to Algolia
      const applicationState = getState();
      const { currentUser } = applicationState.user;
      const { email, createdAt: userCreatedAt } = currentUser?.attributes || {};

      // Need to cancel the 1 hour scheduled email if the listing is published
      // If the updated withing 1 hour
      const isWithin1Hour = moment().diff(userCreatedAt, 'minutes') < 60;
      if (isWithin1Hour) {
        cancelUpcomingMail({});
      }

      const {
        firstName,
        lastName,
        displayName,
        publicData: userPublicData = {},
      } = currentUser.attributes.profile;

      const {
        title = '',
        description = '',
        price,
        state,
        geolocation,
        availabilityPlan = '',
        createdAt,
        publicData = {},
        metadata = {},
      } = response.data.data.attributes || {};
      // console.log(state, '&&& &&& => state');

      if (state == 'published') {
        // We have to know the position of listing
        // to define its default initial order.
        // It will be "total listings"
        sdk.ownListings.query().then(({ data }) => {
          const { meta } = data || {};
          const totalItems = meta?.totalItems;
          const defaultOrder = totalItems ? totalItems : 0;

          // Update in algolia
          createAlgoliaData({
            indexName: process.env.REACT_APP_ALGOLIA_LISTINGS_INDEX,
            objectID: listingId.uuid,
            state,
            _geoloc:
              geolocation && geolocation.lat
                ? { lat: geolocation.lat, lng: geolocation.lng }
                : {},
            title,
            description: description.slice(0, 999),
            price,
            availabilityPlan,
            publicData: {
                ...filterPublicDataToAlgolia(publicData, LISTING_ALOGLIA_REMOVABLE_FIELDS),
            },
            metadata,
            user: {
              id: currentUser.id.uuid,
              firstName,
              lastName,
              email,
              displayName,
              publicData: omit(userPublicData, LISTING_USER_PUBLIC_DATA_REMOVABLE_FIELDS),
            },
            createdAt,
            timestamp: moment(createdAt).unix(),
            order: defaultOrder,
          });

          // Update in sharetribe
          sdk.ownListings.update({
            id: listingId.uuid,
            publicData: {
              order: defaultOrder,
            },
          });
        });

        // Create user record in Algolia when he first time
        // publish his listing. Need to know the total active
        // listings so his store can be ranked.
        userActiveListings(currentUser.id.uuid).then(res => {
          const { totalListings } = res.data || {};

          // User
          createAlgoliaData({
            indexName: process.env.REACT_APP_ALGOLIA_USERS_INDEX,
            objectID: currentUser.id.uuid,
            _geoloc:
              userPublicData.origin?.lng && userPublicData.origin?.lat
                ? {
                  lat: userPublicData.origin.lat,
                  lng: userPublicData.origin.lng,
                }
                : {},
            firstName,
            lastName,
            displayName,
            email,
            publicData: {
              ...filterPublicDataToAlgolia(userPublicData, [
                'profileImage',
                'cart',
              ]),
              totalListings,
            },
            ...(userPublicData.profileImage
              ? { profileImage: userPublicData.profileImage }
              : {}),
            createdAt: userCreatedAt,
            timestamp: moment(userCreatedAt).unix(),
          });
        });
      }

      return response;
    })
    .catch(e => {
      dispatch(publishListingError(storableError(e)));
    });
};


export const requestGenerateAIImages = ({ listingId, ...params }) => async (dispatch, getState, sdk) => {
    try {
        dispatch(generateAIImagesRequest());
        const { data } = await generateAIImages(params);
        const remainingCredits = data.remainingCredits;
        const images = data.images;
        const dataToSave = images.map(image => {
            return {
                secure_url: image.imageUrl,
                public_id: image.publicId,
                height: image.height,
                width: image.width
            }
        });
        dispatch(getCreditsSuccess(remainingCredits));
        dispatch(generateAIImagesSuccess(images));

        // Save generatedImages to sharetribe listing under "generatedImages", as we will not delete them
        // Do this asynchronously
        if (listingId) {
            sdk.ownListings.show({
                id: listingId
            }).then((res) => {
                const listing = res.data.data;
                const existingGeneratedImages = listing.attributes.publicData.generatedImages || [];
                const updatedGeneratedImages = [...existingGeneratedImages, ...dataToSave];
                return sdk.ownListings.update({
                    id: listingId,
                    publicData: {
                        generatedImages: updatedGeneratedImages
                    }
                });
            })
                .catch((error) => {
                    console.error('Failed to update listing:', error);
                });
        };
        return images;
    } catch (error) {
        dispatch(generateAIImagesError(error));
    }
};



// ================ Blog Actions ================ //

// Thunks
export const fetchBlogsByListingId = listingId => async dispatch => {
  dispatch(fetchBlogsRequest());
  try {
    const result = await getBlogsByListingId(listingId);
    dispatch(fetchBlogsSuccess(result.data || []));
  } catch (e) {
    dispatch(fetchBlogsError(e));
  }
};

export const requestUpdateBlog = (id, update) => async dispatch => {
  dispatch(updateBlogRequest(id));
  try {
    const result = await updateBlogPost(id, update);
    dispatch(updateBlogSuccess(result.data));
  } catch (e) {
    dispatch(updateBlogError(id, e));
  }
};

export const requestDeleteBlog = id => async dispatch => {
  dispatch(deleteBlogRequest(id));
  try {
    await deleteBlogPost(id);
    dispatch(deleteBlogSuccess(id));
  } catch (e) {
    dispatch(deleteBlogError(id, e));
  }
};

export const requestPublishBlog = id => async dispatch => {
  dispatch(publishBlogRequest(id));
  try {
    const result = await publishBlogPost(id);
    dispatch(publishBlogSuccess(result.data));
  } catch (e) {
    dispatch(publishBlogError(id, e));
  }
};

// Thunk for generating blog titles
export const requestGenerateBlogTitles = params => async dispatch => {
  dispatch(generateBlogTitlesRequest());
  try {
    // You may need to adjust the API endpoint and payload as per your backend
    const { data } = await generateBlogTitleswithLabels(params);
    dispatch(generateBlogTitlesSuccess(data.blogTitles));
    return data.blogTitles;
  } catch (error) {
    dispatch(generateBlogTitlesError(error));
  }
};

export const requestGenerateBlogs = params => async dispatch => {
    dispatch(generateBlogsRequest());
    try {
        const { data } = await generateBlogs(params);
        dispatch(generateBlogsSuccess(data));
        return data;
    } catch (error) {
        dispatch(generateBlogsError(error));
    }
};

// Add to reducer

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {

  const { listingId: id, tab } = params || {};
  const payload = { id: new UUID(id) };

  const listingResponse = await dispatch(requestShowListing(payload, config))
  const listing = listingResponse?.data?.data;

    const promises = [];
    // If current tab is 'blogs', fetch blog titles
    if (tab === 'blogs' && listing?.attributes?.state === 'published') {
        // You may want to pass additional params as needed
        promises.push(dispatch(fetchBlogsByListingId(id)));
        promises.push(dispatch(requestGenerateBlogTitles({ listingTitle: listing.attributes.title })));
    };

    const transactionProcessAlias =
        listing?.attributes?.publicData?.transactionProcessAlias;
    if (listing && isBookingProcessAlias(transactionProcessAlias)) {
        promises.push(fetchLoadDataExceptions(
            dispatch,
            listing,
            search,
            config.localization.firstDayOfWeek
        ));
    }
    const currentUser = getState().user.currentUser;
    if (currentUser && currentUser.stripeAccount) {
        promises.push(dispatch(fetchStripeAccount()));
    };

    const listingToken = listing?.attributes?.publicData?.listingToken;
    if (listingToken && listingToken.length > 0) {
        promises.push(dispatch(requestGetCredits(listingToken)));
    };

    return Promise.all(promises);
};
